/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Billing_YearlyInputs */



/**
* | output |
* | --- |
* | "Yearly" |
*
* @param {Signup_Billing_YearlyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_billing_yearly = /** @type {((inputs?: Signup_Billing_YearlyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Billing_YearlyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Annuel")
	if (locale === "de") return /** @type {LocalizedString} */ ("Jährlich")
	if (locale === "it") return /** @type {LocalizedString} */ ("Annuale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ежегодно")
	if (locale === "es") return /** @type {LocalizedString} */ ("Anual")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("每年")
	if (locale === "ja") return /** @type {LocalizedString} */ ("年間")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सालाना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Anual")
	return /** @type {LocalizedString} */ ("Yearly")
});